import { useContext } from "react";
import { AuthContext } from "./AuthProvider";
import "./LoginPrompt.css";
import Login from "./Login";

function LoginPrompt() {
  const { manager, fullClient } = useContext(AuthContext);

  if (
    manager.enableAuthSystem === "false" ||
    fullClient === null ||
    Object?.keys(fullClient?.authMethods)?.length === 0
  ) {
    return null;
  }

  return <Login />;
}

export default LoginPrompt;
